import { render, staticRenderFns } from "./Roulet2.vue?vue&type=template&id=6b332731&scoped=true&"
import script from "./Roulet2.vue?vue&type=script&lang=js&"
export * from "./Roulet2.vue?vue&type=script&lang=js&"
import style0 from "./Roulet2.vue?vue&type=style&index=0&id=6b332731&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b332731",
  null
  
)

export default component.exports